/**
 * Mangoes Unified Template
 * Universal template for all Mangoes Unified businesses
 * Sections are shown/hidden based on Portal configuration
 * 
 * Created by: Zee
 */

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PortalProvider } from './context/PortalContext';
import { CustomerAuthProvider } from './context/CustomerAuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import EntrySplash from './components/EntrySplash';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ServicesPage from './pages/ServicesPage';
import EventsPage from './pages/EventsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import DesignOrderPage from './pages/DesignOrderPage';
import PresentationPage from './pages/PresentationPage';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AccountPage from './pages/AccountPage';
import OrdersListPage from './pages/OrdersListPage';
import OrderDetailPage from './pages/OrderDetailPage';
import QuotesListPage from './pages/QuotesListPage';
import PrintOrderIntake from './pages/PrintOrderIntake';
import CustomerOrderPage from './pages/CustomerOrderPage';
import SurveyPage from './pages/SurveyPage';
import WalkthroughMount from './components/WalkthroughMount';

function App() {
  return (
    <PortalProvider>
      <CustomerAuthProvider>
        <EntrySplash />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/design" element={<DesignOrderPage />} />
            <Route path="/presentation" element={<PresentationPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/print-order" element={<PrintOrderIntake />} />
            <Route path="/order/:orderId" element={<CustomerOrderPage />} />
            <Route path="/survey/:surveyId" element={<SurveyPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
            <Route path="/account/orders" element={<ProtectedRoute><OrdersListPage /></ProtectedRoute>} />
            <Route path="/account/orders/:orderId" element={<ProtectedRoute><OrderDetailPage /></ProtectedRoute>} />
            <Route path="/account/quotes" element={<ProtectedRoute><QuotesListPage /></ProtectedRoute>} />
          </Routes>
          {/* Outside <Routes>, so a walkthrough recording survives page changes (2026-09-28). */}
          <WalkthroughMount />
        </BrowserRouter>
      </CustomerAuthProvider>
    </PortalProvider>
  );
}

export default App;
